import { Card, Form, Container, Row, Col, Nav, Tab, InputGroup, Button  } from 'react-bootstrap';
import useMessage from '../../Hooks/useMessage';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import { useEffect, useRef, useState } from 'react';
import { useTheme } from '../../Hooks';
import { buscar } from '../../Utils/Buscar';
import {PROCESAR_PAGO_TC} from "../../Utils";

export function PagoTarjetaCredito(setPagoExitoso,total, subtotal, impuesto = 0, showLoading,hideLoading, idSec = null){
    const inputRef = useRef(null);
    const fechaRef = useRef(null)
    const cvvRef = useRef(null)
    const nombreTarjetaRef = useRef(null)
    const {Message,Error,Warning} = useMessage();
    const {theme} = useTheme();
    const { handleException } = useExceptionHandler();
    const consultaActualId = useRef();

    const handleCardNumberChange = () => {
        let cardNumber = inputRef.current.value.replace(/\D/g, '').substring(0, 19);
        let formattedNumber;

        // Check if the card is an Amex card
        const isAmex = /^3[47]/.test(cardNumber);

        if (isAmex) {
            formattedNumber = cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
        } else {
            formattedNumber = cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
        }

        inputRef.current.value = formattedNumber;
    };
    const handleExpDateChange = () => {
        let expDate = fechaRef.current.value.replace(/\D/g, '').substring(0, 4);
        let formattedExpDate = expDate.replace(/(\d{2})(?=\d)/g, '$1/');
        fechaRef.current.value = formattedExpDate;
    };
    const handleCvvChange = () => {
        let cvv = cvvRef.current.value.replace(/\D/g, '').substring(0, 4);
        cvvRef.current.value = cvv;
    };
    function validarTarjeta(){
        let messages = []
        let expDate = fechaRef.current.value;
        let today = new Date();
        let enteredMonth = parseInt(expDate.substring(0, 2), 10);
        let enteredYear = parseInt(expDate.substring(3, 5), 10);
        let enteredDate = new Date('20' + enteredYear, enteredMonth - 1, 1);

        if(!(enteredMonth <= 12)){
            messages.push("Fecha de expiracion incorrecta: Mes incorrecto ")
        }
        if(!(enteredDate > today)){
            messages.push("Fecha de expiracion incorrecta: La tarjeta esta vencida")
        }
        if(!inputRef.current.value){
            messages.push("Numero de tarjeta es requerido")
        }
        if(!cvvRef.current.value){
            messages.push("CVV es requerido")
        }
        if(cvvRef.current.value.length < 3){
            messages.push("CVV es incorrecto")
        }
        if(!nombreTarjetaRef.current.value){
            messages.push("Nombre del titular es requerido")
        }
        if(messages.length > 0){
            Warning({messages: messages})
        }
        return messages.length === 0;
    }
    
    const pagoTarjeta = (e, total, idSec = null) => {
        showLoading();
        e.preventDefault();
        if(validarTarjeta()){
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = PROCESAR_PAGO_TC;
            let montoTotal = total;
            const impuestos = impuesto;
                buscar(url, {request: {Origen: "M" ,IdSec:idSec,numero: inputRef.current.value,cvv: cvvRef.current.value,fecha: fechaRef.current.value,montoTotal,impuestos}}).then((data) => {
                    if (consultaId === consultaActualId.current) {
                        hideLoading();
                        if (data) {
                            if(data.ErrorMessages.length > 0){
                                Error({messages: data.ErrorMessages})
                                setPagoExitoso(false);
                            }else if (data.WarningMessages.length > 0){
                                Warning({messages: data.WarningMessages})
                                setPagoExitoso(false)
                            }else {
                                Message({messages: data.Messages})
                                setPagoExitoso(true)
                            }
                        }
                    }
                }).catch((error) => {
                    handleException(error);
                    setPagoExitoso(false);
                }).finally(() => {
                    hideLoading();
                })
        }else{
            hideLoading()
        }
    }

    return (
        <div className='bootstrapiso'>
            <Card.Header style={{backgroundColor: '#fff',borderBottom: 'unset'}}>
                <img style={{maxHeight: '50px', position:'absolute', right: '0', marginRight: '45px', paddingBottom: '20px'}} src="/img/tarjetas-pq.png" />
            </Card.Header>
            <Card.Body style={{ height: 'auto' }}>
                <Row style={{ marginBottom: '1rem' }}>
                    <Col sm={8} md={8} className="pt-4">
                        <Row style={{ marginBottom: '1rem' }}>
                            <Col className="form-input" style={{ paddingRight: '0px', maxWidth: '55%', flex: '0 0 55%' }}>
                                <Form.Group className="form-outline" data-mdb-input-init>
                                    <Form.Label htmlFor="cc-number">Número de tarjeta</Form.Label>
                                    <Form.Control
                                        type="tel" maxLength="19"
                                        id="txtNumero"
                                        name="cc-number"
                                        autoComplete="cc-number"
                                        placeholder="•••• •••• •••• ••••"
                                        required
                                        className="form-control cc-number"
                                        ref={inputRef}
                                        onChange={handleCardNumberChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col style={{ paddingRight: '7px', paddingLeft: '7px', maxWidth: '25%', flex: '0 0 22%' }}>
                                <Form.Group className="form-outline" data-mdb-input-init>
                                    <Form.Label htmlFor="cc-exp">Exp.</Form.Label>
                                    <Form.Control
                                        type="tel" maxLength="5"
                                        id="txtFecha"
                                        name="cc-exp"
                                        autoComplete="cc-exp"
                                        placeholder="•• / ••"
                                        required
                                        className="form-control cc-exp"
                                        ref={fechaRef}
                                        onChange={handleExpDateChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col style={{ paddingLeft: '0', maxWidth: '25%', flex: '0 0 22%' }}>
                                <Form.Group className="form-outline" data-mdb-input-init>
                                    <Form.Label htmlFor="cc-cvc">Cvv</Form.Label>
                                    <Form.Control
                                        type="tel" maxLength="4"
                                        id="txtCVV"
                                        name="cc-cvc"
                                        autoComplete="off"
                                        placeholder="•••"
                                        required
                                        className="form-control cc-cvc"
                                        ref={cvvRef}
                                        onChange={handleCvvChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="form-outline" data-mdb-input-init>
                            <Form.Label htmlFor="numeric">Nombre del titular</Form.Label>
                            <Form.Control
                                type="text"
                                id="txtNombre"
                                name="cc-name"
                                autoComplete="off"
                                required
                                className="input-lg form-control"
                                ref={nombreTarjetaRef}

                            />
                        </Form.Group>
                    </Col>
                    <Col sm={4} md={4} className="pt-4">
                        <Row style={{ marginBottom: '1rem' }}>
                            <Col>
                                <Form.Group className="form-outline" data-mdb-input-init>
                                    <Form.Label className="text-right" htmlFor="txtFacturaMontoSinImpuesto">Monto</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="txtFacturaMontoSinImpuesto"
                                        readOnly
                                        className="input-sm form-control text-right"
                                        value={subtotal}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="form-outline" data-mdb-input-init>
                                    <Form.Label className="text-right" htmlFor="txtFacturaImpuesto">Impuesto</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="txtFacturaImpuesto"
                                        readOnly
                                        className="input-sm form-control text-right"
                                        value={impuesto}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="form-outline" data-mdb-input-init>
                            <Form.Label className="text-right" htmlFor="txtFacturaTotal">Total</Form.Label>
                            <Form.Control
                                type="text"
                                id="txtFacturaTotal"
                                readOnly
                                className="input-sm form-control text-right"
                                value={total}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group>
                    <Button type="button" onClick={(e) => pagoTarjeta(e, total, idSec)} className="btn btn-success btn-lg form-control">Procesar</Button>
                </Form.Group>
                <input id="cc-type" name="cc-type" type="hidden" value="" />
            </Card.Body>
        </div>
    )
}